module.exports = __webpack_public_path__ + "img/instagram.d16a5543.png";